import React from "react";
import { formatNumber } from "utils/currencyFormat";
import { formatDayMonth } from "utils/formatDate";
import BtnChuyenQuy from "./ButtonNhapRutChuyenQuy/BtnChuyenQuy";
import BtnNhapQuy from "./ButtonNhapRutChuyenQuy/BtnNhapQuy";
import BtnRutQuy from "./ButtonNhapRutChuyenQuy/BtnRutQuy";
import BtnInQuyTienMat from "./BtnInQuyTienMat";
const QuyTienMatTable = ({
  data,
  dauKy,
  cuoiKy,
  dateFrom,
  dateTo,
  loading,
  onDetailClick,
  config,
  onReload,
  RoleQuyTienMatIn,
  RoleQuyTienMatChuyenQuy,
  RoleQuyTienMatNhapQuy,
  RoleQuyTienMatRutQuy,
  RoleQuyTienMatDuyetQuy,
}) => {
  if (loading) {
    return (
      <div
        className="card border-light mb-3 card-v2"
        style={{ marginTop: "15px" }}
      >
        <div className="card-body card-body-v2 text-center p-5">
          <div className="loader loader-default is-active"></div>
        </div>
      </div>
    );
  }

  if (!data && !dauKy && !cuoiKy) {
    return (
      <div className="card border-light mb-1 card-v2">
        <div className="card-body card-body-v2">
          <div className="row col-sm-12 col-md-12 mb-2">
            {RoleQuyTienMatChuyenQuy && (
              <BtnChuyenQuy
                onReload={onReload}
                RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
              />
            )}
            {RoleQuyTienMatNhapQuy && (
              <BtnNhapQuy
                onReload={onReload}
                RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
              />
            )}
            {RoleQuyTienMatRutQuy && (
              <BtnRutQuy
                onReload={onReload}
                RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
              />
            )}
          </div>
          <div className="text-center red p-4">Không có dữ liệu</div>
        </div>
      </div>
    );
  }

  const displayDateFrom = dateFrom ? dateFrom : new Date("1990-01-01");
  const displayDateTo = dateTo ? dateTo : new Date();
  const totalThu = (data || []).reduce(
    (sum, item) => sum + (Number(item.Thu) || 0),
    0,
  );
  const totalChi = (data || []).reduce(
    (sum, item) => sum + (Number(item.Chi) || 0),
    0,
  );
  return (
    <div
      className="card border-light mb-3 card-v2"
      style={{ marginTop: "15px" }}
    >
      <div className="card-body card-body-v2" style={{ userSelect: "text" }}>
        <div className="row col-sm-12 col-md-12 mb-2 mt-1">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="d-flex">
              {RoleQuyTienMatChuyenQuy && (
                <BtnChuyenQuy
                  onReload={onReload}
                  RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
                />
              )}
              {RoleQuyTienMatNhapQuy && (
                <BtnNhapQuy
                  onReload={onReload}
                  RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
                />
              )}
              {RoleQuyTienMatRutQuy && (
                <BtnRutQuy
                  onReload={onReload}
                  RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
                />
              )}
            </div>
            {RoleQuyTienMatIn && (
              <BtnInQuyTienMat
                data={data}
                dauKy={dauKy}
                cuoiKy={cuoiKy}
                dateFrom={dateFrom}
                dateTo={dateTo}
                config={config}
              />
            )}
          </div>
        </div>
        <div
          className="Left808x200 Table-main-new css-table-ds"
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            border: "1px solid #e3ebf3",
          }}
        >
          <div className="table-mobile table-mobile-hover">
            <div className="custom-table-wrapper">
              <div
                className="table-headers"
                style={{ backgroundColor: "#f8f9fc", display: "flex" }}
              >
                <div
                  className="custom-table-header text-center"
                  style={{
                    width: "20%",
                    justifyContent: "center",
                    borderRight: "1px solid #e3ebf3",
                    borderBottom: "1px solid #e3ebf3",
                    fontSize: "15px",
                  }}
                >
                  <p>Thời gian</p>
                </div>
                <div
                  className="custom-table-header text-left"
                  style={{
                    width: "20%",
                    justifyContent: "flex-start",
                    paddingLeft: "10px",
                    borderRight: "1px solid #e3ebf3",
                    borderBottom: "1px solid #e3ebf3",
                    fontSize: "15px",
                  }}
                >
                  <p>Giao dịch</p>
                </div>
                <div
                  className="custom-table-header text-center"
                  style={{
                    width: "30%",
                    justifyContent: "center",
                    borderRight: "1px solid #e3ebf3",
                    borderBottom: "1px solid #e3ebf3",
                    fontSize: "15px",
                  }}
                >
                  <p>
                    Thu
                    <br />
                    <span className="color-do-bold">
                      {formatNumber(totalThu)}
                    </span>
                  </p>
                </div>
                <div
                  className="custom-table-header text-center"
                  style={{
                    width: "30%",
                    justifyContent: "center",
                    borderBottom: "1px solid #e3ebf3",
                    fontSize: "15px",
                  }}
                >
                  <p>
                    Chi <br />
                    <span className="color-do-bold">
                      {formatNumber(totalChi)}
                    </span>
                  </p>
                </div>
              </div>

              <div className="custom-table-body">
                <div
                  className="custom-table-row"
                  style={{
                    minHeight: "50px",
                    backgroundColor: "#fff",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="custom-table-cell text-center font-weight-bold"
                    style={{
                      width: "20%",
                      justifyContent: "center",
                      borderRight: "1px solid #e3ebf3",
                      borderBottom: "1px solid #e3ebf3",
                      fontSize: "15px",
                    }}
                  >
                    {formatDayMonth(displayDateFrom)}
                  </div>
                  <div
                    className="custom-table-cell text-left"
                    style={{
                      width: "20%",
                      justifyContent: "flex-start",
                      paddingLeft: "10px",
                      borderRight: "1px solid #e3ebf3",
                      borderBottom: "1px solid #e3ebf3",
                      fontSize: "15px",
                    }}
                  >
                    Tiền đầu kỳ
                  </div>
                  <div
                    className="custom-table-cell text-center"
                    style={{
                      width: "60%",
                      justifyContent: "center",
                      borderBottom: "1px solid #e3ebf3",
                    }}
                  >
                    <span
                      className="color-do-bold"
                      style={{ fontSize: "16px" }}
                    >
                      {formatNumber(dauKy)}
                    </span>
                  </div>
                </div>
                {data &&
                  data.map((item, index) => {
                    const isBanHang =
                      config?.isBanHangTraGop === "1" ||
                      config?.IsBanHangTraGop === "1";
                    const isRutQuy = item.NoiDung === "Rút quỹ";
                    if (item.NoiDung === "Bán hàng trả góp" && !isBanHang)
                      return null;
                    return (
                      <div
                        className="custom-table-row"
                        key={index}
                        style={{
                          minHeight: "50px",
                          borderBottom: "none",
                          flexDirection: "row",
                        }}
                      >
                        <div
                          className="custom-table-cell"
                          style={{
                            width: "20%",
                            borderRight: "1px solid #e3ebf3",
                            borderBottom: "none",
                          }}
                        ></div>
                        <div
                          className="custom-table-cell text-left font-weight-500"
                          style={{
                            width: "20%",
                            justifyContent: "flex-start",
                            paddingLeft: "10px",
                            borderRight: "1px solid #e3ebf3",
                            borderBottom: "1px solid #e3ebf3",
                            fontSize: "15px",
                          }}
                        >
                          {item.NoiDung}
                        </div>

                        <div
                          className="custom-table-cell text-center"
                          style={{
                            width: "30%",
                            justifyContent: "center",
                            borderRight: "1px solid #e3ebf3",
                            borderBottom: "1px solid #e3ebf3",
                            fontSize: "15px",
                          }}
                        >
                          {!isRutQuy ? (
                            <p
                              className="color-xanh-bold btn-link"
                              style={{
                                cursor: "pointer",
                                marginTop: 15,
                                textDecoration: "underline",
                              }}
                              onClick={() => onDetailClick(item.NoiDung, "THU")}
                            >
                              {formatNumber(item.Thu)}
                            </p>
                          ) : (
                            <span></span>
                          )}
                        </div>

                        <div
                          className="custom-table-cell text-center"
                          style={{
                            width: "30%",
                            justifyContent: "center",
                            borderBottom: "1px solid #e3ebf3",
                            fontSize: "15px",
                          }}
                        >
                          <p
                            className="color-do-bold btn-link-do"
                            style={{
                              cursor: "pointer",
                              marginTop: 15,
                              textDecoration: "underline",
                            }}
                            onClick={() => onDetailClick(item.NoiDung, "CHI")}
                          >
                            {formatNumber(item.Chi)}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                <div
                  className="custom-table-row"
                  style={{ minHeight: "50px", flexDirection: "row" }}
                >
                  <div
                    className="custom-table-cell text-center font-weight-bold"
                    style={{
                      width: "20%",
                      justifyContent: "center",
                      borderRight: "1px solid #e3ebf3",
                      borderTop: "1px solid #e3ebf3",
                      fontSize: "15px",
                    }}
                  >
                    {formatDayMonth(displayDateTo)}
                  </div>
                  <div
                    className="custom-table-cell text-left"
                    style={{
                      width: "20%",
                      justifyContent: "flex-start",
                      paddingLeft: "10px",
                      borderRight: "1px solid #e3ebf3",
                      fontSize: "15px",
                    }}
                  >
                    Tiền cuối kỳ
                  </div>
                  <div
                    className="custom-table-cell text-center"
                    style={{ width: "60%", justifyContent: "center" }}
                  >
                    <span
                      className="color-do-bold"
                      style={{ fontSize: "16px" }}
                    >
                      {formatNumber(cuoiKy)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuyTienMatTable;
